import {
  clearMessagingSendAttempt,
  MESSAGING_SEND_CUSTODY_KEY,
  type MessagingSendAttempt,
  readMessagingSendAttempt,
  retainMessagingSendAttempt,
  type SendAttemptRead,
} from "./messagingSendAttemptCustody";

/** Reuse the existing identifier-only custody engine in a distinct operation
 * namespace. No authoring, addresses, scope hashes or rendered copy is stored. */
export const PERSONAL_DRAFT_CUSTODY_KEY =
  "hc.admin.messaging.personal-draft-custody.v1";
const store = {
  getItem: (key: string) =>
    window.sessionStorage.getItem(
      key === MESSAGING_SEND_CUSTODY_KEY ? PERSONAL_DRAFT_CUSTODY_KEY : key,
    ),
  setItem: (key: string, value: string) =>
    window.sessionStorage.setItem(
      key === MESSAGING_SEND_CUSTODY_KEY ? PERSONAL_DRAFT_CUSTODY_KEY : key,
      value,
    ),
  removeItem: (key: string) =>
    window.sessionStorage.removeItem(
      key === MESSAGING_SEND_CUSTODY_KEY ? PERSONAL_DRAFT_CUSTODY_KEY : key,
    ),
};
export const personalDraftClientRequestId = (key: string): string | null => {
  const match =
    /^email-assistant:([a-f0-9]{8}-[a-f0-9]{4}-[a-f0-9]{4}-[a-f0-9]{4}-[a-f0-9]{12})$/iu.exec(
      key,
    );
  return match?.[1]?.toLowerCase() ?? null;
};
export const readPersonalDraftAttempt = (
  actor: string,
  contact: string,
): SendAttemptRead => {
  const result = readMessagingSendAttempt(actor, contact, store);
  return result.state === "held" &&
    !personalDraftClientRequestId(result.attempt.requestKey)
    ? { state: "unavailable" }
    : result;
};
export const retainPersonalDraftAttempt = (
  attempt: MessagingSendAttempt,
): boolean =>
  personalDraftClientRequestId(attempt.requestKey) !== null &&
  retainMessagingSendAttempt(attempt, store);
export const clearPersonalDraftAttempt = (
  attempt: MessagingSendAttempt,
): void => clearMessagingSendAttempt(attempt, store);
export const clearPersonalDraftCustody = (): void => {
  try {
    store.removeItem(MESSAGING_SEND_CUSTODY_KEY);
  } catch {
    /* No recovery or write authority. */
  }
};
